/* eslint import/prefer-default-export: 0 */

export const DATE = 'date';
